import {useStore} from '@/store/root-store';
// import {faBolt, faXmark} from '@fortawesome/pro-solid-svg-icons';
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
// import {Popover, Spin} from 'antd';
import {observer} from 'mobx-react';
import {useState} from 'react';
import styled from 'styled-components';
// import {Button} from './Button';
// import styles from '../style.module.scss';
// import {LoadingOutlined} from '@ant-design/icons';

interface Props {
  mode?: 'dark' | 'light' | 'gray';
  size?: 'small' | 'normal';
  customLabel?: string;
  isMinified?: boolean;
}

export const CaAiQuotaInfo = observer(({mode = 'light', size = 'small', customLabel, isMinified = false}: Props) => {
  // const antIcon = <LoadingOutlined style={{fontSize: 12, marginBottom: 2, marginLeft: 5, color: '#7f4ead'}} spin />;

  // const [visible, setVisible] = useState(false);
  const [colorSetup] = useState({
    dark: {
      textColor: '#fff',
    },
    light: {
      textColor: '#4e5156',
    },
    gray: {
      textColor: '#a3a4a4',
    },
  });
  const [sizeSetup] = useState({
    small: {
      fontSize: '12px',
    },
    normal: {
      fontSize: '14px',
    },
  });

  const {
    // plans: {
    //   showSidebarPaymentDrawer,
    // },
    settings: {
      customer: {
        profile: {
          quotaUtilization,
          // topUpAiQuota,
          // topUpAiQuotaLoading,
          // isWhitelabel,
        },
        // getCustomerQuota,
      },
    },
  } = useStore('');

  // const popoverContent = (<div style={{position: 'relative'}}>
  //   <IconWrapper>
  //     <FontAwesomeIcon icon={faBolt} style={{color: '#1FAC47', height: 23, margin: 'auto'}}/>
  //   </IconWrapper>
  //   <PopoverTitle>100 More AI Quota for just $25</PopoverTitle>
  //   <PopoverDesc>Speed up your content production with more AI Quota</PopoverDesc>
  //   <PopoverFooterContainer>
  //     <Button color='green'
  //       disabled={topUpAiQuotaLoading}
  //       onClick={async () => {
  //         setVisible(false);
  //         await topUpAiQuota();
  //         getCustomerQuota();
  //       }}>Top Up AI Quota</Button>
  //     <ViewPlansBtn onClick={() => {
  //       showSidebarPaymentDrawer();
  //       setVisible(false);
  //     }}>View plans</ViewPlansBtn>
  //   </PopoverFooterContainer>
  //   <div style={{position: 'absolute', top: -20, right: 0}}>
  //     <FontAwesomeIcon
  //       icon={faXmark}
  //       style={{height: '20px', color: '#A3A4A4', cursor: 'pointer'}}
  //       onClick={() => setVisible(false)}/>
  //   </div>
  // </div>);

  return <Wrapper sizeSetup={sizeSetup} size={size}>
    {!isMinified ? <Label colorSetup={colorSetup} mode={mode}>{customLabel ?? 'AI Quota'}: {quotaUtilization?.ca?.allowedAiContentGeneration?.consumed}/{quotaUtilization?.ca?.allowedAiContentGeneration?.total}</Label> : null}
    {/* Uncomment when BE is ready and we revisit this feature */}
    {/* {quotaUtilization?.ca?.allowedAiContentGeneration?.consumed <= quotaUtilization?.ca?.allowedAiContentGeneration?.total ? <Popover
      overlayClassName={styles.TopUpPopupOverlay}
      color='#313337'
      overlayInnerStyle={{
        backgroundColor: '#313337',
        width: 310,
        borderRadius: 5,
      }}
      content={popoverContent}
      trigger='click'
      placement='bottomLeft'
      onVisibleChange={visible => setVisible(visible)}
      visible={visible}
      autoAdjustOverflow={true}
    ><>
        {!isWhitelabel ? <TopUp onClick={() => setVisible(true)}>Top Up</TopUp>: <></>}{topUpAiQuotaLoading ? <Spin indicator={antIcon}/> : null}
      </>
    </Popover> : null} */}
  </Wrapper>;
});

const Wrapper = styled.div<{sizeSetup: any; size: 'small' | 'normal'}>`
 font-size: ${p => p.sizeSetup[p.size].fontSize};
 font-weight: 300;
 cursor: default;
 display: inline-block;
`;
const Label = styled.span<{colorSetup?: any; mode?: 'dark' | 'light' | 'gray'}>`
 color: ${p => p.colorSetup[p.mode].textColor};
 margin-right: 5px;
`;
// const IconWrapper = styled.div`
//  width: 50px;
//  height: 50px;
//  border-radius: 100%;
//  background-color: #1FAC4726;
//  display: flex;
//  margin-left: auto;
//  margin-right: auto;
//  margin-top: 23px;
// `;
// const PopoverTitle = styled.div`
//  color: #fff;
//  font-weight: 600;
//  font-size: 16px;
//  margin-top: 20px;
//  margin-bottom: 6px;
//  max-width: 280px;
//  text-align: center;
// `;
// const PopoverDesc = styled.div`
//  color: #E8E8E8;
//  font-weight: 400;
//  font-size: 14px;
//  max-width: 280px;
//  text-align: center;
// `;
// const PopoverFooterContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   margin-top: 20px;
//   margin-bottom: 20px;
// `;
// const TopUp = styled.span`
//  color: #2d6cca;
//  text-decoration:  underline;
//  cursor: pointer;
// `;
// const ViewPlansBtn = styled.span`
//  fontSize: 14px;
//  color: #fff;
//  text-decoration: underline;
//  margin-top: auto;
//  margin-bottom: auto;
//  margin-right: 20px;
//  cursor: pointer;
// `;
